class ReadMoreBlock {
  /**
   * @param {string} blockId - The unique identifier for this read-more block
   */
  constructor(blockId) {
    this.blockId = blockId;
    this.button = document.querySelector(`[data-read-more-button="${blockId}"]`);
    this.text = document.querySelector(`[data-read-more-text="${blockId}"]`);
    
    if (this.button && this.text) {
      this.init();
    }
  }
  
  init() {
    if (!this.button || !this.text) return;
    
    this.button.addEventListener('click', () => {
      this.toggle();
    });
  }
  
  toggle() {
    if (!this.text || !this.button) return;
    
    const isExpanded = this.text.classList.contains('show');
    
    this.text.classList.toggle('show');
    this.button.classList.toggle('hidden');
    
    // Update ARIA attributes for accessibility
    this.button.setAttribute('aria-expanded', String(!isExpanded));
    this.text.setAttribute('aria-hidden', String(isExpanded));
  }
}

// Initialize all read-more blocks on the page
document.addEventListener('DOMContentLoaded', () => {
  const allBlocks = document.querySelectorAll('[data-read-more-button]');
  allBlocks.forEach(button => {
    const blockId = button.getAttribute('data-read-more-button');
    if (blockId) {
      new ReadMoreBlock(blockId);
    }
  });
});
